import { PluginSetup as ExpresionParser } from '@leverege/expression-parser';
import Tokenizers from './tokenizers/PluginSetup.js';
import TokenStylizers from './tokenStylizers/PluginSetup.js';
export default {
  install(plg) {
    Tokenizers.install(plg);
    TokenStylizers.install(plg);
    ExpresionParser.install(plg);
  }
};